export const webClientId = 'AIzaSyDknua_rHE4yQbT8xPMXqZYkwunw42TtFw';